import { AppState } from 'core/redux/rootReducer';
import { FirebaseReducerState } from 'firebase/types/redux/firebaseState';

const firebase = (state: AppState): FirebaseReducerState => state.firebase;
const token = (state: AppState): string | null => firebase(state).token;
const user = (state: AppState): any => firebase(state).user;

export default { token, user };
